module.exports = __webpack_public_path__ + "static/media/chevron-double-up.072c67a6.svg";